import { createFileRoute } from "@tanstack/react-router";

import { UnsupportedBrowserPage } from "@/uiKit/pages/UnsupportedBrowserPage";

export const Route = createFileRoute("/unsupported-browser")({
  component: UnsupportedBrowserPage,
});
